<div class="px-4">
  @if (mediaState()?.CurrentlyPlayingTypeCode !== 'Radio') {
    <div class="tv">
      <div class="screen ms-auto">
        @if (
      mediaState()?.CurrentlyPlayingTypeCode === 'Movie' || mediaState()?.CurrentlyPlayingTypeCode === 'Television'
      ) {
          <youtube-player (ready)="savePlayer($event)"
                          height="270"
                          width="480"> </youtube-player>
        } @else if (mediaState()?.CurrentlyPlayingTypeCode === 'Input') {
          <div>
            <p class="text-center text-white">Casting {{ mediaState()?.CurrentlyPlayingCode }}</p>
          </div>
        }
        @if (buttonCode$ | async; as button) {
          <small [@pulse]="buttonCode$ | async">{{ button }}</small>
        }
      </div>
    </div>
  }
</div>